import http from 'utils/http';

export const getPipeline = () => http
  .get('v1/organizations/{{organizationId}}/pipeline/')
  .then((res) => res.data);

export const createPipelineStage = (data) => http
  .post('v1/organizations/{{organizationId}}/pipeline/stages/', data)
  .then((res) => res.data);

export const updatePipelineStage = (stageId, data) => http
  .patch(`v1/organizations/{{organizationId}}/pipeline/stages/${stageId}/`, data)
  .then((res) => res.data);

export const deletePipelineStage = (stageId) => http
  .delete(`v1/organizations/{{organizationId}}/pipeline/stages/${stageId}/`)
  .then((res) => res.data);

export const reorderPipelineStages = (stageIds) => http
  .patch('v1/organizations/{{organizationId}}/pipeline/stages/reorder/', { stage_ids: stageIds })
  .then((res) => res.data);

export const syncPipelineStages = (stages) => http
  .put('v1/organizations/{{organizationId}}/pipeline/stages/sync/', { stages })
  .then((res) => res.data);

export const getDeals = (params = {}) => {
  const query = params.stage_key ? `?stage_key=${encodeURIComponent(params.stage_key)}` : '';
  return http
    .get(`v1/organizations/{{organizationId}}/deals/${query}`)
    .then((res) => res.data);
};

export const createDeal = (data) => http
  .post('v1/organizations/{{organizationId}}/deals/', data)
  .then((res) => res.data);

export const updateDeal = (dealId, data) => http
  .patch(`v1/organizations/{{organizationId}}/deals/${dealId}/`, data)
  .then((res) => res.data);

export const deleteDeal = (dealId) => http
  .delete(`v1/organizations/{{organizationId}}/deals/${dealId}/`)
  .then((res) => res.data);

export const moveDeal = (dealId, stageKey) => http
  .patch(`v1/organizations/{{organizationId}}/deals/${dealId}/move/`, { stage_key: stageKey })
  .then((res) => res.data);
